import styled from 'styled-components'

export const CalendarIconStyled = styled.span`
  display: flex;
  align-items: center;
  padding: 0 ${(props) => props.theme.typography.pxToRem(12)} 0 0;
`
